/*
 * Purpose : For logging out user after 10 min of idle session.
 * Author : Soumya
 * Copyright (c) - Globalfoundries
 *
 */

import React, { useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import SessionTimeoutDialog from "./SessionTimeoutDialog";
//import { Auth } from "aws-amplify";

let countdownInterval;
let timeout;

const SessionTimeout = ({ isAuthenticated, logOut }) => {
    const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = useState(0);
    const idleTimer = useRef(null);

    const clearSessionTimeout = () => {
        clearTimeout(timeout);
    };

    const clearSessionInterval = () => {
        clearInterval(countdownInterval);
    };

    //Logout of session
    const handleLogout = async (isTimedOut = false) => {
        try {
            setTimeoutModalOpen(false);
            clearSessionInterval();
            clearSessionTimeout();
            logOut();
            console.log("on clicking logout", isAuthenticated);
        } catch (err) {
            console.error(err);
        }
    };

    // Continue the session
    const handleContinue = () => {
        setTimeoutModalOpen(false);
        clearSessionInterval();
        clearSessionTimeout();
    };

    //User active on the session
    const onActive = () => {
        if (!timeoutModalOpen) {
            console.log("active user")
            clearSessionInterval();
            clearSessionTimeout();
        }
    };

    // User being idle on the session
    const onIdle = () => {
        const delay = 1000 * 1;
        console.log("idle user")
        console.log(isAuthenticated, !timeoutModalOpen)
        if (isAuthenticated && !timeoutModalOpen) {
            timeout = setTimeout(() => {
                let countDown = 30;
                setTimeoutModalOpen(true);
                setTimeoutCountdown(countDown);
                countdownInterval = setInterval(() => {
                    if (countDown > 0) {
                        setTimeoutCountdown(--countDown);
                    } else {
                        handleLogout(true);
                    }
                }, 1000);
            }, delay);
        }
    };

    return (
        <>
            <IdleTimer
                ref={idleTimer}
                onActive={onActive}
                onIdle={onIdle}
                debounce={250}
                timeout={900000}
            />
            <SessionTimeoutDialog
                countdown={timeoutCountdown}
                onContinue={handleContinue}
                onLogout={() => handleLogout(false)}
                open={timeoutModalOpen}
            />
        </>
    );
}

export default SessionTimeout;